import React, { Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";

import Homepage from "./homepage/index";
import PlayerDetail from "./homepage/PlayerDetail";
import About from "./homepage/About";
import Planes from "./homepage/Planes";
import Spec from "./homepage/Spec";
import Faq from "./homepage/Faq";
import Terms from "./homepage/Terms";
import Privacy from "./homepage/Privacy";
import GraciasPago from "./homepage/GraciasPago";
import Recuperacion from "./homepage/Recuperacion";
import Login from "./Auth/Login";
import Perfil from "./homepage/Perfil";

const Index = (props) => {
  return (
    <Fragment>
      <AuthProvider>
      <Router forceRefresh>
        <Switch>
          <Route exact path="/">
            <Homepage />
          </Route>
          <Route exact path="/player/detail">
            <PlayerDetail />
          </Route>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/planes">
            <Planes />
          </Route>
          <Route exact path="/spec">
            <Spec />
          </Route>
          <Route exact path="/faq">
            <Faq />
          </Route>
          <Route exact path="/terminos-de-servicio">
            <Terms />
          </Route>
          <Route exact path="/aviso-de-privacidad">
            <Privacy />
          </Route>
          <Redirect from="/privacy" to="/aviso-de-privacidad" />
          <Redirect from="/terms" to="/terminos-de-servicio" />
          <Route exact path="/gracias-pago">
            <GraciasPago />
          </Route>
          <Route exact path="/recuperacion">
            <Recuperacion />
          </Route>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/perfil">
            <Perfil />
          </Route>
        </Switch>
      </Router>
      </AuthProvider>
    </Fragment>
  );
};

export default Index;
